var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonBilable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28583_37235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 8.66176C13.3337 11.9951 11.0003 13.6618 8.22699 14.6284C8.08177 14.6776 7.92402 14.6753 7.78033 14.6218C5.00033 13.6618 2.66699 11.9951 2.66699 8.66176V3.99509C2.66699 3.81828 2.73723 3.64871 2.86225 3.52369C2.98728 3.39866 3.15685 3.32842 3.33366 3.32842C4.66699 3.32842 6.33366 2.52842 7.49366 1.51509C7.6349 1.39442 7.81456 1.32812 8.00033 1.32812C8.18609 1.32812 8.36576 1.39442 8.50699 1.51509C9.67366 2.53509 11.3337 3.32842 12.667 3.32842C12.8438 3.32842 13.0134 3.39866 13.1384 3.52369C13.2634 3.64871 13.3337 3.81828 13.3337 3.99509V8.66176Z",
    stroke: "#F59E0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.32812V7.99479",
    stroke: "#F59E0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6719H8.00667",
    stroke: "#F59E0B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28583_37235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonBilable);
export default __webpack_public_path__ + "static/media/nonBilable.faee617e40085eed4c1e0b66971f3606.svg";
export { ForwardRef as ReactComponent };